// extracted by mini-css-extract-plugin
export default {"container":"Instructor_container__GRj2X","wrapper":"Instructor_wrapper__dk9Hx","body":"Instructor_body__ra48w","content":"Instructor_content__G2laU","back":"Instructor_back__--xeQ"};